<div class="gw-rd-vip-tiers-page-widget-empty-item">
    <div class="gw-rd-vip-tiers-page-widget-empty-item__line" />
</div>

<style lang="postcss">
    .gw-rd-vip-tiers-page-widget-empty-item {
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        margin: 0 auto;

        &__line {
            width: 100%;
            height: 1px;
            background-color: hsl(216, 14%, 79%);
        }
    }
</style>
